import React, { useContext, useState,useEffect } from "react";
import { HotelOwnerContext } from "./HotelOwnerContext";
import Pagination from "../../Pagination";
import { useFormik  } from "formik";
import * as yup from "yup"
import "./hotelOwnerHotels.css"
import Spinner from "../../Spinner";
export default function HotelOwnerHotels() {  


  
  const { data, availableHotels, formik, setRelToDelete, newHotelData, hotelOwnerHotels, postsPerPage, currentPage, paginate,username,baseUrl}=useContext(HotelOwnerContext)
  // console.log(username)
  const shouldPaginate = hotelOwnerHotels.length > 4
  const displayedHotels = shouldPaginate ? newHotelData : hotelOwnerHotels
  
  const [transToDel,setTransToDel]=useState(false) //State to determine whether wa are sending a n add or a delete request
  const [allTransporters,setAllTransporters]=useState([])//Used to hold all the transporters
  const [filteredTransporters,setFilteredTransporters]=useState([])//used to hold all the filtered transporters
 
  
  const fetchTransporters=async()=>{//Function to fetch transporters
    try {
      const res=await fetch(`${baseUrl}/transporters`)
      const transData=await res.json()
      // console.log(transData)
      setAllTransporters(transData)

    } catch (error) {
      console.error(`An error occurred fetching tansporters,${error}`)
    }
    
  }
  useEffect(()=>{
fetchTransporters(allTransporters)
  },[])//fetches once
   
  //  ["Hotel_name","hotel_owner_username","Transporter_name"]
  const formik_add_trans=useFormik({
    initialValues:{
      Hotel_name:"",
      hotel_owner_username:username,
      Transporter_name:""
    },
    validationSchema:yup.object().shape({
      Hotel_name:yup.string("Hotel_name should be a string").required("Hotel_name is required").typeError("Hotel_name should be a string"),
      hotel_owner_username:yup.string("hotel_owner_username should be a string").required("hotel_owner_username is required").typeError("hotel_owner_username should be a string"),
      Transporter_name:yup.string("Transporter_name should be a string").required("Transporter_name is required").typeError("Transporter_name should be a string")      
    }),
    onSubmit:async(values,{setSubmitting})=>{
      try {
        if(transToDel){
          await handleDeleteTrans(values)
          formik_add_trans.resetForm()
          setTransToDel(false)
        }
  else{
    await handleAddTrans(values)
    formik_add_trans.resetForm()
    setTransToDel(false)
  }
      } catch (error) {
        console.error(`error sending requests`,error)
      }
     finally{
      setSubmitting(false)
     }
    }
  })


  useEffect(() => {
    if (formik_add_trans.values.Hotel_name) {
      const selectedHotel = formik_add_trans.values.Hotel_name;
      
      // Check if transporters and the selected hotel exist
      if (allTransporters && allTransporters.length > 0) {
        const filtered = allTransporters.filter((transporter) => {
         if(transporter){
          // Assuming transporter has a 'hotels' field, check if it's not associated with the selected hotel
          return !transporter.Hotels || !transporter.Hotels.some(hotel => hotel.name === selectedHotel);
         }
        });
  
        setFilteredTransporters(filtered); // Update state with the filtered transporters
      }
    } else {
      // Reset transporters when no hotel is selected
      setFilteredTransporters(allTransporters);
    }
  }, [formik_add_trans.values.Hotel_name, allTransporters]);
  // console.log(formik_add_trans.values,"Username :",username)

  useEffect(()=>{
    if (username){
      formik_add_trans.setFieldValue("hotel_owner_username",username)
    }
  },[username])
 

  const handleAddTrans=async(values)=>{
    try {
      const res=await fetch(`${baseUrl}/login/hotel_owners`,{
        method:"POST",
        headers:{
          "Content-Type":"application/json"
        },
         body:JSON.stringify(values)
      })
      if (res.ok){
        alert( `${values.Transporter_name} added successfully`)        
      }
    else{
      const result=await res.json()
      alert(`Error deleting transporter ${result.Error || result.Message}`)
    }
    } catch (error) {
      console.error("Error adding transporters",error)
    }
  }
// const handleDeleteTrans
const handleDeleteTrans=async(values)=>{
  try{
    const res=await fetch(`${baseUrl}/login/hotel_owners`,{
      method:"DELETE",
      headers:{
        "Content-Type":"application/json"
      },
       body:JSON.stringify(values)
    })
    if (res.ok){
      alert( `${values.Transporter_name} added successfully`)        
    }
  else{
    const result=await res.json()
    alert(`Error deleting transporter ${result.Error || result.Message}`)
   
  }
  } catch (error) {
    console.error("Error adding transporters",error)
  }
}

function handleDeleteClick (hotelName){
  formik.setFieldValue("name",hotelName)
  setRelToDelete(true)
}
// console.log(formik_add_trans.values)

  return (
    <div className="bg-gray-100 flex flex-col justify-between mt-2  mb-16">      
      <div>
      {data.length > 0 ? (
        <div>
          {data.map((owner, index) => (
            <div
              key={index}
              className="bg-white border border-gray-300 rounded-lg p-4 mb-4"
            >
              <h2 className="text-xl">{owner.username}</h2>
              <p className="mb-1">
                <strong>Email:</strong> {owner.email}
              </p>
              <div className="mt-2">
                <h3 className="text-blue-500">Hotels:</h3>
                {displayedHotels && displayedHotels.length > 0 ? (
                  <div className="hotel-grid mt-4 mb-10">
                    {displayedHotels.map((hotel, index) => (
                                <div key={index} className="hotel-card space-x-2 flex">        
                                <form onSubmit={formik.handleSubmit} className="">
                                  <button type="submit" onClick={()=>handleDeleteClick(hotel.name)} className=" bg-red-500 rounded-lg ml-2 delete-button">
                                  DELETE
                                  </button>
                                 </form>
                                 <div className="hotel-container">
                                   <img
                                     src={hotel.image_url}
                                     alt={hotel.name}
                                     className="hotel-image"                                    
                                     onError={(e) => e.target.style.display = 'none'}
                                   />
                                   <div className="data-overlay" key={index} >
                                     <p className="text-white italic">{hotel.name}</p>
                                     <p className="text-white italic">{hotel.email}</p>
                                     <h4 className="text-white italic">{hotel.location}</h4>
                                     <p className="text-white italic">{hotel.goods_type}</p>
                                   </div>       
                                          
                                 </div>
                               </div>
                    ))}
                  </div>
                ) : (
                  <p>Seems you do not have any hotels</p>
                )}
              </div>
            </div>
          ))}
        </div>
      ) : (
        <p>You seem to have no hotels ,want to add </p>
      )}
      </div>
      {shouldPaginate ? <Pagination postsPerPage={postsPerPage} currentPage={currentPage} paginate={paginate} totalPosts={hotelOwnerHotels.length} /> : null}
      <div className="mt-4">
        {availableHotels.length > 0 ? 
        
          <form onSubmit={formik.handleSubmit}>
            <label htmlFor="hotel_name">Select a hotel</label>
            <select
              value={formik.values.hotel_name}
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              onChange={formik.handleChange}
              name="hotel_name"
              id="hotel_name"
              required
            >
              <option value="">Select a hotel</option>
              {availableHotels.map((hotel, index) => (
                <option key={index} value={hotel.name}>
                  {hotel.name}
                </option>
              ))}
            </select>
            <button
              type="submit"
              className="bg-blue-500 rounded-lg disabled:opacity-50 ml-20"
              disabled={formik.isSubmitting || !formik.isValid}
            >
              Send request
            </button>
          </form>
         : null}
      </div>
      <div>{displayedHotels.length>0 ?
        <div>
      <p>Want to add transporter to hotels</p>
        <form onSubmit={formik_add_trans.handleSubmit}>
          <select value={formik_add_trans.values.Hotel_name} name="Hotel_name" onChange={formik_add_trans.handleChange} onBlur={formik_add_trans.handleBlur} className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline">
            <option value="">Select the hotel to use</option>
        {displayedHotels.map((hotel,index)=>{
          return <option key={hotel.id} value={hotel.name}>{hotel.name}</option>          
          // {formik_add_trans.errors.Hotel_name && formik_add_trans.touched.Hotel_name?<p className=" text-red-500 italic">{formik_add_trans.errors.Hotel_name}</p>:null}
        })}  
        
        </select>
        {formik_add_trans.errors.Hotel_name && formik_add_trans.touched.Hotel_name?<p className=" text-red-500 italic">{formik_add_trans.errors.Hotel_name}</p>:null}
        {filteredTransporters.length>0?<div>
          <select value={formik_add_trans.values.Transporter_name} name="Transporter_name" className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
        onChange={formik_add_trans.handleChange}  onBlur={formik_add_trans.handleBlur}
        >
          <option>Select a transporter</option>
          {filteredTransporters.map((trans,index)=>(
            <option key={trans.id} value={trans.name}>{trans.name}</option>            
          ))}
          
          {/* {formik_add_trans.errors.Transporter_name && formik_add_trans.touched.Transporter_name? <p>{formik_add_trans.errors</p>:null} */}
          </select>
          {formik_add_trans.errors.Transporter_name && formik_add_trans.touched.Transporter_name?<p className=" text-red-500 italic">{formik_add_trans.errors.Transporter_name}</p>:null}
        </div>:<p>Sorry no transporters to add</p>}
        <button type="submit" className="bg-blue-500 rounded-lg disabled:opacity-50" disabled={formik_add_trans.isSubmitting ||!formik_add_trans.isValid}>send request</button>
        </form>
      </div>:null}</div>
      
    </div>
  );
}

